'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function GAFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-vwgby0qad", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-vwgby0qad)" }, /* @__PURE__ */ React.createElement("path", { fill: "#40a8ff", d: "M0 16h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 8h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#73be4a", d: "M0 0h32v8H0z" })))
  );
}

export { GAFlag };
//# sourceMappingURL=GA.mjs.map
